import React from 'react';
import Countdown, { zeroPad } from 'react-countdown';
import { useIsSmallScreenMediaQuery } from '../lib/isSmallScreen';
import { handleAppLogout } from '../lib/utils';
import { DeprecatedModal, ModalText, ModalTitle, ModalConfirmationButton, ModalCancelButton } from './DeprecatedModal';
import { useIsSkySlopeMobileApp } from './utils';

interface IProps {
  closeModal: () => void;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const TimeoutModal = (props: IProps) => {
  const isMobileApp = useIsSkySlopeMobileApp();
  const isSmallScreen = useIsSmallScreenMediaQuery();
  const isMobileAppOrSmallScreen = isMobileApp || isSmallScreen;

  // @ts-expect-error -- This code was written prior to enforcing lint rules
  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const renderer = ({ minutes, seconds }) => {
    return (
      <span>
        {zeroPad(minutes, 1)}:{zeroPad(seconds)}
      </span>
    );
  };

  const actions = (
    <>
      <ModalCancelButton
        isMobileOrSmallScreen={isMobileAppOrSmallScreen}
        onClick={handleAppLogout}
        aria-label="sign out"
      >
        Sign Out
      </ModalCancelButton>
      <ModalConfirmationButton
        buttonStyle={isMobileAppOrSmallScreen ? { margin: '10px 0px 20px' } : {}}
        onClick={props.closeModal}
        aria-label="stay signed in"
      >
        Stay Signed In
      </ModalConfirmationButton>
    </>
  );

  const content = (
    <div>
      <div style={{ marginBottom: isMobileAppOrSmallScreen ? '26px' : '18px' }}>
        <ModalText>
          You've been inactive for a while. {isMobileAppOrSmallScreen && <br />} For security reasons, we're{' '}
          {!isMobileAppOrSmallScreen && <br />}
          automatically {isMobileAppOrSmallScreen && <br />} signing you out in{' '}
          <span style={{ fontWeight: 'bold' }}>
            <Countdown date={Date.now() + 300000} renderer={renderer} onComplete={handleAppLogout} /> minutes.
          </span>
        </ModalText>
      </div>
      <ModalText>
        Choose "Stay Signed In" to continue {isMobileAppOrSmallScreen && <br />} working or "Sign Out" if you're{' '}
        {!isMobileAppOrSmallScreen && <br />} done. {isMobileAppOrSmallScreen && <br />} All progress will be saved.
      </ModalText>
    </div>
  );

  return (
    <DeprecatedModal
      data-spec="timeout-modal"
      hideCloseButton
      // TODO: This markup is invalid. ModalTitle renders an h3. `title` prop gets wrapped in a DialogTitle
      // which renders an h2. This makes the markup <h2><h3>Your session is about to expire</h3></h2> which is invalid.
      // React error: <h3> cannot appear as a child of <h2>
      title={
        <ModalTitle
          customStyle={
            isMobileAppOrSmallScreen
              ? { letterSpacing: '0px', marginBottom: '32px', textAlign: 'center', fontSize: '32px' }
              : {}
          }
        >
          Your session is {isMobileAppOrSmallScreen && <br />} about to expire
        </ModalTitle>
      }
      content={content}
      actionButtons={actions}
      isMobileOrSmallScreen={isMobileAppOrSmallScreen}
      modalStyles={{
        titlePadding: isMobileAppOrSmallScreen ? '0px' : '40px 40px 0px',
        minHeight: '336px',
        minWidth: '300px',
        justifyContent: isMobileAppOrSmallScreen ? 'center' : 'space-around',
        maxHeight: isMobileAppOrSmallScreen ? 'none' : '',
        actionButtonsStyle: isMobileAppOrSmallScreen
          ? {
              paddingTop: '10px',
              paddingRight: '8px',
              paddingBottom: '0px',
              justifyContent: 'center',
              flexDirection: 'column-reverse',
            }
          : {},
        modalContentStyle: isMobileAppOrSmallScreen ? { textAlign: 'center', padding: '0px', fontSize: '17px' } : {},
      }}
    />
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default TimeoutModal;
